import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
export const OPEN_ATTACHMENTS_REMOVE_MODAL_HANDLER = {
  topic: TOPIC_NAMES.OPEN_ATTACHMENTS_REMOVE_MODAL,
  type: 'MODAL',
  componentLoader: () => import('../wrappers/AttachmentsRemoveModal')
};